<accredible-themeable-multiple-search-input *ngIf="customAttribute"
  [label]="customAttribute.label"
  [options]="customAttribute.options"
  [optionsLabelKey]="'label'"
  [selectedOptions]="selectedOptions"
  [usingStaticOptions]="true"
  (optionsChanged)="handleSelectAnyInputSubmit($event)">
</accredible-themeable-multiple-search-input>
